<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      activeItem: 'topa-topa',
      opened: false,
      listHeightStyle: { },
      collection: '',
      mpcLink: false
    }
  },

  props: {
    communityUrl: '',
    uri: '',
    subpage: '',
    initCollection: ''
  },

  mounted() {
      // modify the URL hack based on how the page is loaded
      if (window.location.search) {
          this.mpcLink = window.location.search;
          this.mpcLink = this.mpcLink.replace('?', '');
          this.collection = this.mpcLink;
          this.setActive(this.mpcLink, false);
      } else if(window.location.pathname === `${this.communityUrl}/communities` || window.location.pathname === `${this.communityUrl}/communities/`) {
          this.setActive(this.initCollection);
      } else if(this.getDiff(window.location.pathname, `${this.communityUrl}/communities/`)) {
          this.setActive(this.getDiff(window.location.pathname, `${this.communityUrl}/communities/`), false);
      } else {
          this.setActive(this.initCollection);
          if(this.getActiveCollectionFromUrl()) {
              this.setActive(this.getActiveCollectionFromUrl());
          }
      }
  },
  computed: {
    activeCollection() {
        return this.getActiveCollectionFromUrl();
    }
  },
  methods: {
    getDiff: function(string, diffBy) {
      return string.split(diffBy).join('');
    },
    getActiveCollectionFromUrl: function () {
      if(window.location.pathname == `${this.communityUrl}/communities`) {
          return false;
      }
      return this.getDiff(window.location.pathname, `${this.communityUrl}/communities/`);
    },
    isActive: function (collection) {
      return collection == this.activeItem;
    },
    setActive: function (collection, updateUrl) {
        if(updateUrl) {
            const url = this.communityUrl;
            history.pushState({}, collection, `${url}/communities/${collection}`);
        }
        if(updateUrl === false) {
            const url = this.communityUrl;
            const anchor = $('.collection-view__section');
            let offset = window.innerWidth > 992 ? $(".main-nav").outerHeight() + $('.community-nav').height() : $(".main-nav").outerHeight();
            offset = anchor.offset().top - offset + 'px';
            // history.pushState({}, collection, `${url}/communities/${collection}`);
            $('html,body').animate({scrollTop: offset}, 600, 'swing');
        }
        this.activeItem = collection;
    },
    getHeight(event) {
      var listHeight = this.$refs.collection.clientHeight + 'px';
      Vue.set(this.listHeightStyle, 'height', listHeight);
    }
  }
}

</script>
